<template>
  <div class="bige cont cgu" style="padding-top:150px;">
    <h1>Mentions légales</h1>
    <article>
      <h2>Editeur et hébergeur</h2>
      <address>
        <p>
          Okaïdi SAS au capital de 2.928.240 €, RCS Lille Métropole 398.110.445,
        </p>
        <p>
          Siège social : 162 Boulevard de Fourmies - BP 615 - 59061 Roubaix
          Cedex 1 – France
        </p>
        <p>
          Tél : <a href="tel:+33969392390">09 69 39 23 90</a> (appel non
          surtaxé).
        </p>
        <p>n° TVA : TVA intracommunautaire : FR 29 398 110 445</p>
        <p>email : <a href="mailto:idtroc@idkids.com">idtroc@idkids.com</a></p>
      </address>
    </article>
    <article>
      <h2>Directeur de la publication</h2>
      <p>Grégoire Duforest, en sa qualité de Directeur Général</p>
    </article>
    <article>
      <h2>Propriété Intellectuelle</h2>
      <p>
        L'intégralité de ce site est protégée par les législations françaises et
        internationales relatives à la propriété intellectuelle. Tous les droits
        de reproduction sont réservés. L'ensemble des textes composant les pages
        du site ne peut, conformément à l'article L122-4 du code de la propriété
        intellectuelle, faire l'objet d'une quelconque représentation ou
        reproduction, intégrale ou partielle, sur quelque support que ce soit,
        sans l'autorisation expresse et préalable de IDKids.
      </p>
    </article>
  </div>
</template>

<script>
export default {
  name: "MentionsLegales"
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/MentionsLegales.vue